import React, {FunctionComponent} from "react";
import {RatingUser} from "/src/domain/challenges/ChallengeUserRatingData";
import makeStyles from "@mui/styles/makeStyles";
import {useTranslation} from "react-i18next";
import {Avatar, Typography, Link} from "@mui/material";
import {trimName} from "/src/domain/shared/trimName";
import {links} from "/src/domain/shared/links";

export type RatingHeaderProps = {
    user: RatingUser
};

export const RatingHeader: FunctionComponent<RatingHeaderProps> = ({user}) => {
    const {t} = useTranslation();
    const classes = useStyles();

    const profileLink = `${links.origin}/profile?${user.id}`;
    return (
        <>
            <Typography variant="h1" className={classes.header}>{t('rating')}</Typography>
            <div className={classes.nameContainer}>
                <a href={profileLink}>
                    <Avatar src={user.avatarUrl} variant="circular" className={classes.avatar}/>
                </a>
                <Typography 
                    variant="h2" 
                    role="h2"
                    component={Link} 
                    underline="hover" 
                    href={profileLink} 
                    className={classes.name}>{trimName(user.firstName, user.lastName)}</Typography>
            </div>
        </>
    )
}

const useStyles = makeStyles(muiTheme => ({
    nameContainer: {
        color: muiTheme.palette.primary.contrastText,
        padding: '1rem 4rem 1rem 9rem',
        fontSize: '1.15rem',
        fontWeight: 500,
        background: `url(${require('../../assets/icons/primary_rect.svg')})`,
        backgroundRepeat: 'no-repeat',
        display: 'inline-block',
        backgroundPositionX: 'right',
        backgroundSize: 'cover',
        position: "relative",
        marginTop: "3.25rem",
        marginBottom: "3.75rem"
    },
    avatar: {
        width: '7.5rem',
        height: '7.5rem',
        position: "absolute",
        left: "1rem",
        transform: "translate(0%,-50%)",
        top: "50%"
    },
    name: {
        fontSize: "1.25rem",
        color: "white",

    },
    header: {
        fontSize: "1.5rem",
        marginLeft: "1.5rem",
        marginTop: "1.5rem"
    }
}));